export const topicsData = [
  { name: '动作大片', count: '2.8万', color: 'bg-primary-500', hot: true },
  { name: '悬疑烧脑', count: '1.9万', color: 'bg-accent-500', hot: true },
  { name: '喜剧合家欢', count: '1.6万', color: 'bg-secondary-500', hot: false },
  { name: '科幻巨制', count: '2.1万', color: 'bg-primary-400', hot: true },
  { name: '爱情经典', count: '1.4万', color: 'bg-accent-400', hot: false },
  { name: '恐怖惊悚', count: '1.2万', color: 'bg-secondary-400', hot: false },
  { name: '国剧精选', count: '2.5万', color: 'bg-primary-300', hot: true },
  { name: '韩剧热播', count: '1.8万', color: 'bg-accent-300', hot: true },
  { name: '动画动漫', count: '1.1万', color: 'bg-secondary-300', hot: false },
  { name: '纪录写实', count: '0.8万', color: 'bg-primary-200', hot: false },
  { name: '综艺娱乐', count: '1.5万', color: 'bg-accent-200', hot: false },
];

export const commentsData = [
  {
    name: '光影追梦人',
    time: '2小时前',
    content: '春色影视资源真的太全了，想看的冷门老片都能找到，画质也相当不错，推荐给所有电影爱好者！流畅不卡顿，观影体验拉满。',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20young%20Chinese%20film%20enthusiast%20with%20warm%20amber%20lighting%2C%20artistic%20bokeh%20background%2C%20movie%20theater%20vibe%2C%20soft%20portrait%20photography&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    name: '深夜放映室',
    time: '5小时前',
    content: '用了好几个平台，还是春色影视最稳定。新片更新速度很快，分类也很清晰，找片效率高多了。已经推荐给身边朋友了。',
    avatar: 'https://readdy.ai/api/search-image?query=Artistic%20portrait%20of%20a%20Chinese%20woman%20with%20cinematic%20warm%20lighting%2C%20film%20reel%20reflection%2C%20soft%20focus%20background%2C%20movie%20buff%20aesthetic&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    name: '剧荒拯救者',
    time: '1天前',
    content: '最爱话题标签功能，刷到自己喜欢的类型直接点进去就是一堆好片，省时省力。高清免费不收费这点太良心了，必须支持！',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20a%20Chinese%20student%20watching%20movies%2C%20cozy%20cinematic%20lighting%2C%20popcorn%20vibe%2C%20soft%20bokeh%2C%20film%20lover%20atmosphere&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
];

export const faqData = [
  {
    q: '春色影视真的完全免费吗？',
    a: '是的，春色影视所有电影和电视剧均免费在线观看，不收取任何费用，无需会员注册即可畅享高清画质。我们致力于为用户提供免费不收费的优质观影服务。',
  },
  {
    q: '播放会卡顿或缓冲吗？',
    a: '春色影视采用先进的CDN加速技术，确保流畅播放不缓冲。只要您的网络环境正常，即可享受如丝般顺滑的观影体验，告别卡顿烦恼。',
  },
  {
    q: '资源更新频率如何？',
    a: '我们保持每日更新的运营节奏，最新热门电影和电视剧全集会在上线后第一时间同步。电影大全持续扩充，确保您不错过任何一部好片。',
  },
  {
    q: '支持哪些设备观看？',
    a: '春色影视全面适配电脑、平板和手机端，无论在家还是出行，随时随地打开浏览器即可畅享高清免费在线观影，无需下载任何插件。',
  },
];

export const rankingData = [
  { rank: 1, title: '暗夜追踪', type: '动作 / 悬疑', score: '9.2', trend: 'up', desc: '年度最受期待动作大片，硬核打斗场面' },
  { rank: 2, title: '时光旅人', type: '科幻 / 冒险', score: '8.9', trend: 'up', desc: '穿越时空的视觉奇观震撼来袭' },
  { rank: 3, title: '人间烟火', type: '剧情 / 家庭', score: '9.0', trend: 'new', desc: '温暖治愈系年度口碑佳作' },
  { rank: 4, title: '迷雾深渊', type: '悬疑 / 惊悚', score: '8.7', trend: 'up', desc: '烧脑反转让人欲罢不能' },
  { rank: 5, title: '长安旧事', type: '古装 / 历史', score: '8.8', trend: 'new', desc: '史诗级制作还原盛唐风华' },
];

export const featuresData = [
  {
    icon: 'ri-movie-2-line',
    title: '海量电影大全',
    desc: '汇聚数万部高清电影资源，囊括动作、悬疑、喜剧、科幻、爱情等全类型，满足不同观影口味。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '不缓冲流畅播放',
    desc: '领先的流媒体加速技术，高清画质秒加载，告别缓冲等待，享受丝滑观影新体验。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全设备免费在线',
    desc: '电脑、平板、手机全面适配，无需安装APP，浏览器打开即看，随时随地享受免费高清观影。',
  },
  {
    icon: 'ri-fire-line',
    title: '最新热门每日更新',
    desc: '热门电影资源库每日更新，院线新片、热门电视剧全集第一时间同步，绝不错过精彩。',
  },
];

export const updatesData = [
  { time: '2026-08-01', tag: '上新', content: '暑期档热门影片《暗夜追踪》高清版正式上线春色影视电影大全' },
  { time: '2026-07-30', tag: '更新', content: '国产剧《长安旧事》全36集高清全集更新完毕，免费在线观看' },
  { time: '2026-07-28', tag: '热播', content: '悬疑烧脑大片《迷雾深渊》热度突破新高，单日观影人数超10万' },
  { time: '2026-07-25', tag: '专题', content: '「夏日清凉恐怖夜」专题上线，精选20部高分惊悚片不缓冲流畅播放' },
  { time: '2026-07-22', tag: '上新', content: '科幻巨制《时光旅人》抢先上线，视觉特效震撼来袭' },
  { time: '2026-07-19', tag: '公告', content: '平台服务器全面升级，观影加载速度提升40%，体验更加丝滑' },
  { time: '2026-07-15', tag: '热门', content: '《人间烟火》口碑持续发酵，成为本月最受好评的剧情类电影' },
];

export const indexData = [
  { title: '动作冒险', count: '328部', desc: '硬核激战场面集结' },
  { title: '科幻奇幻', count: '256部', desc: '想象力的无限边界' },
  { title: '悬疑推理', count: '189部', desc: '烧脑反转一次看够' },
  { title: '喜剧欢乐', count: '215部', desc: '轻松一刻笑到停不下来' },
  { title: '爱情文艺', count: '172部', desc: '触碰心灵的故事' },
  { title: '历史古装', count: '143部', desc: '穿越时空的史诗之旅' },
  { title: '纪录纪实', count: '98部', desc: '真实世界的震撼' },
];

export const cardsData = [
  {
    title: '《暗夜追踪》：年度动作巅峰之作',
    desc: '顶级导演联手实力演员，打造近年最震撼的动作场面，拳拳到肉的真实打斗配合紧凑剧情，让人目不暇接。',
    tag: '动作大片',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20scene%20with%20dramatic%20lighting%20and%20intense%20atmosphere%2C%20noir%20style%2C%20dark%20alley%20with%20neon%20reflections%2C%20film%20grain%20texture%2C%20professional%20movie%20poster%20quality&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    title: '《时光旅人》：穿越视觉奇观',
    desc: '一部将时间旅行与人性深度结合的科幻巨制，画面极尽瑰丽，每一帧都是壁纸级别的视觉享受。',
    tag: '科幻巨制',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20time%20travel%20portal%20and%20cosmic%20nebulae%2C%20cinematic%20color%20grading%2C%20warm%20amber%20and%20teal%20tones%2C%20epic%20scale%2C%20movie%20poster%20aesthetic&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    title: '《人间烟火》：治愈系口碑佳作',
    desc: '平凡人家的温情故事，细腻的情感刻画让无数观众泪目，当之无愧的年度口碑冠军。',
    tag: '剧情经典',
    image: 'https://readdy.ai/api/search-image?query=Warm%20family%20drama%20movie%20scene%20with%20golden%20hour%20lighting%2C%20Chinese%20family%20gathering%20at%20dinner%20table%2C%20nostalgic%20atmosphere%2C%20soft%20focus%20cinematic%20photography%2C%20heartwarming%20mood&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    title: '《迷雾深渊》：烧脑悬疑新标杆',
    desc: '层层反转的叙事结构，不到最后一刻绝对猜不到真相，悬疑片爱好者不可错过的饕餮盛宴。',
    tag: '悬疑烧脑',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20thriller%20movie%20scene%20with%20foggy%20forest%20and%20dark%20shadows%2C%20atmospheric%20cinematography%2C%20suspenseful%20mood%2C%20cool%20muted%20tones%20with%20warm%20accents%2C%20film%20noir%20inspired&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    title: '《长安旧事》：盛世风华再现',
    desc: '精良的服化道还原千年古都的辉煌气象，史诗级叙事将历史与传奇完美交织，国剧新高度。',
    tag: '国剧精选',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20scene%20with%20warm%20lantern%20light%2C%20Tang%20dynasty%20aesthetic%2C%20golden%20and%20red%20ornaments%2C%20cinematic%20wide%20shot%2C%20historical%20epic%20film%20look&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    title: '《极限营救》：惊险刺激全程高能',
    desc: '从头燃到尾的特工动作片，紧凑的叙事节奏搭配炫目的特技场面，肾上腺素飙升之作。',
    tag: '动作大片',
    image: 'https://readdy.ai/api/search-image?query=High-octane%20rescue%20mission%20movie%20scene%20with%20explosive%20action%2C%20urban%20cityscape%20background%2C%20dramatic%20orange%20and%20teal%20color%20grade%2C%20cinematic%20motion%20blur%2C%20blockbuster%20aesthetic&width=800&height=500&seq=card-06&orientation=landscape',
  },
  {
    title: '《星河恋人》：跨越星际的浪漫',
    desc: '当科幻遇上爱情，一段发生在遥远星系的动人故事，绝美画面与真挚情感的双重享受。',
    tag: '爱情经典',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20sci-fi%20movie%20scene%20with%20starry%20night%20sky%20and%20two%20silhouettes%2C%20ethereal%20cosmic%20background%2C%20warm%20purple%20and%20pink%20nebula%2C%20dreamy%20cinematic%20photography%2C%20soft%20focus&width=800&height=500&seq=card-07&orientation=landscape',
  },
];

export const mediaData = [
  {
    title: '《暗夜追踪》幕后特辑',
    desc: '导演携主创团队深度解析动作场面的拍摄秘密，揭秘那些令人窒息的真实特技是如何完成的。',
    duration: '24:18',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20action%20movie%20filming%20with%20camera%20crew%20and%20stunt%20coordination%2C%20cinematic%20lighting%20setup%2C%20professional%20film%20production%20environment%2C%20warm%20tungsten%20lighting&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    title: '《时光旅人》视效解析',
    desc: '顶尖视效团队展示如何用CGI技术构建令人惊叹的时空穿越场景，每一帧都是艺术。',
    duration: '18:42',
    image: 'https://readdy.ai/api/search-image?query=VFX%20studio%20with%20artist%20working%20on%20futuristic%20sci-fi%20scene%20composition%2C%20multiple%20monitors%20showing%20digital%20art%2C%20cool%20blue%20ambient%20lighting%2C%20creative%20workspace&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    title: '《人间烟火》导演专访',
    desc: '导演畅谈创作初衷，分享拍摄过程中的动人瞬间，以及那些隐藏在镜头背后的真实故事。',
    duration: '32:05',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20interview%20in%20warm%20studio%20setting%20with%20soft%20key%20light%2C%20movie%20posters%20in%20background%2C%20professional%20video%20production%20setup%2C%20intimate%20atmosphere&width=640&height=360&seq=media-03&orientation=landscape',
  },
];

export const carouselData = [
  {
    title: '暑期档爆款合集',
    desc: '精选暑期最热影片，一站式观影指南',
    image: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20collage%20with%20cinematic%20warm%20lighting%2C%20film%20strip%20border%20design%2C%20dramatic%20action%20and%20adventure%20themes%2C%20golden%20hour%20aesthetic%2C%20movie%20poster%20style&width=900&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '高分悬疑片单',
    desc: '烧脑爱好者的终极盛宴',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20collection%20with%20dark%20noir%20atmosphere%2C%20shadowy%20figures%20and%20clues%2C%20cinematic%20lighting%20with%20smoke%2C%20detective%20theme%2C%20dramatic%20composition&width=900&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '经典重温系列',
    desc: '那些年我们追过的银幕经典',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20with%20classic%20movie%20scenes%20projected%20on%20screen%2C%20nostalgic%20cinema%20atmosphere%2C%20warm%20sepia%20tones%2C%20old%20Hollywood%20glamour%2C%20film%20grain%20texture&width=900&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '国剧精选推荐',
    desc: '年度不可错过的国产好剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20epic%20scene%20with%20ancient%20architecture%20and%20traditional%20costumes%2C%20golden%20warm%20lighting%2C%20cinematic%20wide%20composition%2C%20palace%20setting%2C%20historical%20elegance&width=900&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '科幻视觉盛宴',
    desc: '突破想象力的未来世界',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20cityscape%20with%20flying%20vehicles%20and%20holographic%20displays%2C%20sci-fi%20cinematic%20aesthetic%2C%20neon%20lights%20and%20dark%20sky%2C%20epic%20scale%2C%20cyberpunk%20inspired%20film%20look&width=900&height=500&seq=carousel-05&orientation=landscape',
  },
  {
    title: '动画世界漫游',
    desc: '从吉卜力到皮克斯的奇幻旅程',
    image: 'https://readdy.ai/api/search-image?query=Magical%20animated%20film%20scene%20with%20vibrant%20colors%20and%20dreamy%20atmosphere%2C%20hand-drawn%20style%20inspired%20art%2C%20fantasy%20landscape%20with%20floating%20islands%2C%20warm%20and%20inviting%20mood&width=900&height=500&seq=carousel-06&orientation=landscape',
  },
];

export const aboutData = {
  title: '关于春色影视',
  content: '春色影视是一家专注于高清免费在线观影的流媒体平台，致力于为广大电影爱好者提供最新热门电影资源库。我们汇聚电影大全，涵盖动作、悬疑、喜剧、科幻、爱情等全类型影片及电视剧全集，持续更新满足不同观影需求。平台采用先进的CDN加速技术，确保不缓冲流畅播放，让每一位用户都能享受丝滑般的观影体验。免费不收费是我们的初心，让好电影触手可及是我们的使命。',
};

export const contactData = {
  title: '联系我们',
  subtitle: '有任何建议或合作意向，欢迎与我们取得联系',
  email: 'contact@chunseys.com',
};

export const appData = {
  title: '随时随地 畅享观影',
  subtitle: '春色影视全面适配移动端，无需下载安装，手机浏览器打开即可畅享高清免费在线观影。收藏本站，好片随时看。',
};